import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  IconButton
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import { useNavigate } from "react-router-dom";

const ValidationLeads = () => {
  const [leads, setLeads] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    fetch("https://core-bankers-backend.vercel.app/get-all-leads")
      .then((res) => res.json())
      .then((data) => setLeads(data.leads || []))
      .catch((err) => console.error("Fetch Leads Error:", err));
  }, []);

  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h6" gutterBottom>
        Validation Leads
      </Typography>
      <Paper>
        <TableContainer>
          <Table>
            <TableHead sx={{ backgroundColor: "#f5f5f5" }}>
              <TableRow>
                <TableCell>ID</TableCell>
                <TableCell>Name</TableCell>
                <TableCell>Mobile</TableCell>
                <TableCell>CIBIL</TableCell>
                <TableCell>Loan Type</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Employment</TableCell>
                <TableCell>Created By</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {leads.map((lead) => (
                <TableRow key={lead.id}>
                  <TableCell>{lead.id}</TableCell>
                  <TableCell>{lead.name}</TableCell>
                  <TableCell>{lead.mobile}</TableCell>
                  <TableCell>{lead.cibil || "—"}</TableCell>
                  <TableCell>{lead.loan_type}</TableCell>
                  <TableCell>₹ {lead.amount}</TableCell>
                  <TableCell>{lead.employment_type || "—"}</TableCell>
                  <TableCell>{lead.created_by || "—"}</TableCell>
                  <TableCell>
                    <IconButton
                      color="primary"
                      onClick={() => navigate(`/view-lead/${lead.id}`)}
                    >
                      <VisibilityIcon />
                    </IconButton>
                  </TableCell>
                </TableRow>
              ))}
              {!leads.length && (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    No leads found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Box>
  );
};

export default ValidationLeads;